<template>
  <div class="downlo">
    <div>Fazendo Download...</div>
    <div class="d-flex">
      <div class="mr-1">
        Caso o download não tenha iniciado sozinho, por favor
      </div>
      <div class="clique" @click="download">Clique aqui</div>
    </div>
  </div>
</template>
<script>
import { seloDiagnosticoEvidenciasAPI } from "../API/seloDiagnosticoEvidenciasAPI";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      evidence: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    download() {
      seloDiagnosticoEvidenciasAPI
        .download(
          this.$route.params.evidenceId,
          this.$route.query.uf,
          this.$route.query.parceiro
        )
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
  },
  mounted() {
    this.setLoading(true);

    this.download();
  },
};
</script>
<style scoped>
.downlo {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.clique {
  color: var(--corPrimaria);
  font-weight: bold;
  cursor: pointer;
}
</style>
